var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { Status } from './Resolver';
import { createPlaceholderSegment } from './Segments';
import { NodeMatcher, NaviNodeType } from './Node';

var ContextMatcher =
/** @class */
function (_super) {
  __extends(ContextMatcher, _super);

  function ContextMatcher(options) {
    return _super.call(this, options, true) || this;
  }

  ContextMatcher.prototype.execute = function () {
    var childContextResolution = this.resolver.resolve(this.env, this.constructor.childContextResolvable);

    if (childContextResolution.status !== Status.Ready) {
      return {
        resolutionIds: [childContextResolution.id],
        segment: createPlaceholderSegment(this.env, childContextResolution.error, this.appendFinalSlash)
      };
    } // Need te memoize env, as its the key for memoization by the resolver


    var childContext = childContextResolution.value;
    var childEnv;

    if (!this.last || this.last.childContext !== childContext) {
      childEnv = __assign({}, this.env, {
        context: childContext
      });
      this.last = {
        childContext: childContext,
        childEnv: childEnv
      };
    } else {
      childEnv = this.last.childEnv;
    }

    var childNodeResolution = this.resolver.resolve(childEnv, this.constructor.childNodeResolvable);

    if (childNodeResolution.status !== Status.Ready) {
      return {
        resolutionIds: [childNodeResolution.id],
        segment: createPlaceholderSegment(childEnv, childNodeResolution.error, this.appendFinalSlash)
      };
    } // Memoize matcher so its env prop can be used as a key for the resolver


    var node = childNodeResolution.value;
    var matcher;

    if (this.last.node !== node) {
      matcher = new node({
        env: childEnv,
        resolver: this.resolver,
        withContent: this.withContent,
        appendFinalSlash: this.appendFinalSlash
      });
      this.last = __assign({}, this.last, {
        node: node,
        matcher: matcher
      });
    } else {
      matcher = this.last.matcher;
    }

    return matcher.getResult();
  };

  ContextMatcher.isNode = true;
  ContextMatcher.type = NaviNodeType.Context;
  return ContextMatcher;
}(NodeMatcher);

export { ContextMatcher };
export function createContext(maybeChildContextResolvable, maybeChildNodeResolvable) {
  var _a;

  if (process.env.NODE_ENV !== 'production') {
    if (maybeChildContextResolvable === undefined) {
      console.warn("The first argument to createContext() should be the child context, but it was undefined. If you want to define an empty context, instead pass null.");
    }
  }

  var childNodeResolvable = maybeChildNodeResolvable.isNode ? function () {
    return maybeChildNodeResolvable;
  } : maybeChildNodeResolvable;
  var childContextResolvable = typeof maybeChildContextResolvable !== 'function' ? function () {
    return maybeChildContextResolvable;
  } : maybeChildContextResolvable;
  return _a =
  /** @class */
  function (_super) {
    __extends(class_1, _super);

    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    return class_1;
  }(ContextMatcher), _a.childNodeResolvable = childNodeResolvable, _a.childContextResolvable = childContextResolvable, _a;
}